import withModal from '../../../../components/global/modal/withModal';
import FaceTagPhoto from './FaceTagPhoto';

const FACE_TAG_PHOTO_MODAL = 'FACE_TAG_PHOTO_MODAL';

const FaceTagPhotoModal = withModal(FaceTagPhoto, {
  name: FACE_TAG_PHOTO_MODAL,
  type: 'full',
  className: 'photo-overlay-viewer',
  hideHeader: true,
});

export default FaceTagPhotoModal;
